module.exports = __webpack_public_path__ + "img/RO.9b3f5bd5.svg";